module.exports = __webpack_public_path__ + "img/jquery.523358e4.svg";